/* DC.SPORTS - extrait de layout/theme.liquid le 31/08/2026.
   Code identique a l'original, deplace ici pour etre mis en cache
   par le navigateur au lieu d'etre reecrit dans chaque page. */
(function(){
  "use strict";
  if (document.getElementById('dc-tiroir-promo-guard')) return;   /* garde anti-doublon */

  /* Ambassadeur : sa remise est superieure et automatique, on ne lui montre
     RIEN — ni message promo, ni comparatif. Rendu par Liquid cote serveur. */
  if (window.DC_AMBASSADEUR) return;

  var g = document.createElement('span');
  g.id = 'dc-tiroir-promo-guard';
  g.style.display = 'none';
  (document.body || document.documentElement).appendChild(g);

  var ID_MSG  = 'dc-tiroir-promo';
  var MESSAGE = '−15 % sur « Offres en cours (éligibles) », dès 2 articles avec le code AUGUST15, hors point bleu 🔵';

  /* ------------------------------------------------------------------
     Regles de calcul — reprises de snippets/dc-prix-club.liquid
     Club : -25 % Yonex/Babolat/Victor/Li-Ning · -30 % Maxbolt/Felet/
            Flex Power/Apacs/FZ Forza, uniquement sur raquettes,
            chaussures, sacs et textile. Calcul sur le PRIX BARRE quand
            il existe, sinon sur le prix magasin.
     AUGUST15 : -15 % du prix magasin, sur tout sauf les produits
            tagues « exclu-offres » (le point bleu), des 2 articles.
     Un seul code s'applique par commande.
     Ambassadeurs exclus : remise superieure et automatique, aucun affichage.
     ------------------------------------------------------------------ */
  var T25 = ['yonex','babolat','victor','li-ning','lining'];
  var T30 = ['maxbolt','felet','flex power','apacs','fzforza','fz forza'];
  /* Types de produits couverts par le bareme club. A completer ici si une
     nouvelle famille entre dans les 4 collections club. */
  var TYPES_CLUB = ['raquette','chaussure','sac','maillot','short','sweat',
                    'vetement','pantalon','polo','veste','jupe','robe'];

  function sansAccent(s){
    return (s||'').toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'');
  }
  function contientUn(foin, aiguilles){
    for (var i=0;i<aiguilles.length;i++){ if (foin.indexOf(aiguilles[i])!==-1) return true; }
    return false;
  }
  function euros(cents){
    return (cents/100).toFixed(2).replace('.', ',') + ' €';
  }

  var cacheProduits = {};   /* handle -> donnees produit */

  function produit(handle){
    if (Object.prototype.hasOwnProperty.call(cacheProduits, handle)){
      return Promise.resolve(cacheProduits[handle]);
    }
    return fetch('/products/' + encodeURIComponent(handle) + '.js', {credentials:'same-origin'})
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(p){ cacheProduits[handle] = p; return p; })
      .catch(function(){ cacheProduits[handle] = null; return null; });
  }

  function tauxClub(p){
    if (!p) return 0;
    var td = sansAccent((p.tags||[]).join('|') + '|' + (p.vendor||''));
    var t = 0;
    if (contientUn(td, T25)) t = 25;
    if (contientUn(td, T30)) t = 30;
    if (!t) return 0;
    if (!contientUn(sansAccent(p.type||''), TYPES_CLUB)) return 0;  /* hors des 4 collections club */
    return t;
  }

  function estExclu(p){
    if (!p) return false;
    return sansAccent((p.tags||[]).join('|')).indexOf('exclu-offres') !== -1;
  }

  /* Renvoie {club: centimes, august: centimes} pour le panier courant. */
  function calculer(panier){
    var handles = [];
    panier.items.forEach(function(it){
      if (handles.indexOf(it.handle) === -1) handles.push(it.handle);
    });
    return Promise.all(handles.map(produit)).then(function(){
      var club = 0, baseAugust = 0, qteEligible = 0;
      panier.items.forEach(function(it){
        var p = cacheProduits[it.handle];
        var unitaire = it.original_price || it.price;   /* avant remise de ligne */
        var qte = it.quantity;

        if (!estExclu(p)){                 /* AUGUST15 */
          qteEligible += qte;
          baseAugust  += unitaire * qte;
        }

        var t = tauxClub(p);               /* prix club */
        if (t){
          var barre = 0;
          if (p && p.variants){
            for (var i=0;i<p.variants.length;i++){
              if (p.variants[i].id === it.variant_id){
                barre = p.variants[i].compare_at_price || 0;
                break;
              }
            }
          }
          var base = (barre > unitaire) ? barre : unitaire;
          var prixClub = Math.round(base * (100 - t) / 100);
          if (prixClub < unitaire) club += (unitaire - prixClub) * qte;
        }
      });
      return { club: club, eligibles: qteEligible,
               august: (qteEligible >= 2) ? Math.round(baseAugust * 0.15) : 0 };
    });
  }

  /* ---------------------------- rendu ---------------------------- */

  var STYLE_BOITE = 'display:block;margin:10px 0;padding:10px 12px;border-radius:10px;' +
    'background:#f6f2f7;color:#241f2b;font-size:13px;line-height:1.35;text-align:center;' +
    'font-weight:600;box-sizing:border-box;';

  var etat = { codeClub: null, remises: null, applique: '' };

  function ligneOffre(libelle, montant, gagnante){
    return '<div style="display:flex;justify-content:space-between;gap:10px;padding:3px 0;' +
      (gagnante ? 'font-weight:800;color:#0c7a4d;' : 'font-weight:500;opacity:.7;') + '">' +
      '<span>' + (gagnante ? '● ' : '○ ') + libelle + '</span>' +
      '<span>' + (montant > 0 ? '−' + euros(montant) : 'ne s’applique pas') + '</span></div>';
  }

  function ligneCompacte(phrase, codeACopier){
    var bouton = codeACopier
      ? '<span class="dc-tp-code" style="display:none;">' + codeACopier + '</span>' +
        '<button type="button" class="dc-tp-copier" style="cursor:pointer;border:0;border-radius:7px;' +
        'padding:5px 10px;font-size:12px;font-weight:700;background:#e11b22;color:#fff;white-space:nowrap;">Copier</button>'
      : '';
    return '<div style="margin-top:8px;padding-top:8px;border-top:1px solid rgba(36,31,43,.15);' +
      'display:flex;align-items:center;gap:8px;text-align:left;font-size:12.5px;line-height:1.3;">' +
        '<span style="flex:1 1 auto;">' + phrase + '</span>' + bouton +
    '</div>';
  }

  /* Renvoie la ligne utile, ou une chaine vide s'il n'y a rien a dire.
     Le message promo general n'est plus repete ici : il vit dans le bandeau
     du haut et dans le popup, la ou le client decouvre l'offre. */
  function contenu(){
    var html = '';
    var r = etat.remises;
    if (!r) return html;
    var applique = (etat.applique || '').toUpperCase();
    var code = etat.codeClub;

    /* Visiteur ordinaire : pas de club, seul AUGUST15 peut jouer. */
    if (!code){
      if (applique === 'AUGUST15') return html;   /* deja applique, Shopify l'affiche */
      if (r.august > 0){
        return html + ligneCompacte(
          'Ton code : <b>AUGUST15</b> · <b>−' + euros(r.august) + '</b> dès 2 articles', 'AUGUST15');
      }
      /* Un seul article eligible : la remise est a portee. On propose quand
         meme le code — Shopify le garde au panier et l'active tout seul des
         que le 2e article arrive. */
      if (r.eligibles === 1){
        return html + ligneCompacte(
          'Ajoute un 2<sup>e</sup> article et <b>AUGUST15</b> te fait <b>−15 %</b> sur les deux.', 'AUGUST15');
      }
      return html;
    }

    /* Membre d'un club partenaire : les deux offres se comparent. */
    if (r.club <= 0 && r.august <= 0) return html;

        /* Membre d'un club partenaire : on montre LES DEUX codes, nommes,
       le meilleur en tete. Un seul s'applique par commande. */
    if (r.club <= 0 && r.august <= 0) return html;

    var clubGagne = r.club > r.august;
    var meilleur  = clubGagne ? code : 'AUGUST15';
    var gain      = clubGagne ? r.club : r.august;

    if (applique === meilleur.toUpperCase()) return html;

    var comparatif = '<div style="text-align:left;font-size:12.5px;line-height:1.3;">'
      + ligneOffre(code, r.club, clubGagne)
      + ligneOffre('AUGUST15 <span style="font-weight:500;opacity:.7;">dès 2 articles</span>', r.august, !clubGagne)
      + '</div>';

    var phrase;
    if (applique){
      var dejaGagne = (applique === 'AUGUST15') ? r.august
                    : (applique === code.toUpperCase() ? r.club : 0);
      var ecart = gain - dejaGagne;
      if (ecart <= 0) return html;
      phrase = 'Avec <b>' + meilleur + '</b> tu paierais <b>' + euros(ecart) + '</b> de moins.';
    } else {
      phrase = 'Un seul code par commande — prends <b>' + meilleur + '</b>.';
    }

    return html + comparatif + ligneCompacte(phrase, meilleur);
  }

  function brancherCopie(noeud){
    var b = noeud.querySelector('.dc-tp-copier');
    var c = noeud.querySelector('.dc-tp-code');
    if (!b || !c) return;
    b.addEventListener('click', function(){
      var texte = c.textContent.trim();
      var fini = function(){ b.textContent = 'Copié ✓'; b.disabled = true; b.style.opacity = '.65'; };
      try {
        if (navigator.clipboard && navigator.clipboard.writeText){
          navigator.clipboard.writeText(texte).then(fini, function(){});
          return;
        }
      } catch(e){}
      try {
        var t = document.createElement('textarea');
        t.value = texte; t.setAttribute('readonly','');
        t.style.position = 'fixed'; t.style.left = '-9999px';
        document.body.appendChild(t); t.select();
        document.execCommand('copy'); document.body.removeChild(t);
        fini();
      } catch(e){}
    });
  }

  function creerMessage(doc){
    var msg = doc.createElement('div');
    msg.id = ID_MSG;
    msg.style.cssText = STYLE_BOITE;
    var h = contenu();
    msg.innerHTML = h;
    if (!h) msg.style.display = 'none';
    brancherCopie(msg);
    return msg;
  }

  function rafraichir(racine){
    if (!racine) return;
    var n = racine.querySelector('#' + ID_MSG);
    if (!n) return;
    var h = contenu();
    n.innerHTML = h;
    n.style.display = h ? 'block' : 'none';
    brancherCopie(n);
  }

  /* Deux etats du tiroir :
     - panier plein -> le message se pose juste AU-DESSUS de « Payer la commande » ;
     - panier vide  -> ce bouton n'existe pas, on remplace alors « Continuer vos achats ». */
  function poser(racine){
    if (!racine) return false;
    if (racine.querySelector('#' + ID_MSG)) return true;

    var doc = racine.ownerDocument || document;

    var payer = racine.querySelector('.cd-checkout-section-button');
    if (payer && payer.parentNode){
      payer.parentNode.insertBefore(creerMessage(doc), payer);
      return true;
    }

    var continuer = racine.querySelector('.btn-continue');
    if (!continuer){
      var candidats = racine.querySelectorAll('button, a');
      for (var i = 0; i < candidats.length; i++){
        if ((candidats[i].textContent || '').trim().toLowerCase() === 'continuer vos achats'){
          continuer = candidats[i]; break;
        }
      }
    }
    if (continuer && continuer.parentNode){
      continuer.parentNode.insertBefore(creerMessage(doc), continuer);
      return true;
    }

    var bas = racine.querySelector('.cd-checkout-section-container, .bottom-section');
    if (bas){
      bas.insertBefore(creerMessage(doc), bas.firstChild);
      return true;
    }

    return false;
  }

  /* Recalcul, au plus une fois par etat de panier. */
  var signature = null, enCours = false;

  function recalculer(racine){
    if (enCours) return;
    enCours = true;
    fetch('/cart.js', {credentials:'same-origin'})
      .then(function(r){ return r.json(); })
      .then(function(panier){
        var applique = '';
        (panier.discount_codes || []).forEach(function(d){ if (d.applicable) applique = d.code; });
        etat.applique = applique;
        var sig = panier.items.map(function(i){ return i.variant_id + 'x' + i.quantity; }).join(',') + '|' + applique;
        if (sig === signature) return null;
        signature = sig;
        if (!panier.items.length){ etat.remises = null; rafraichir(racine); return null; }
        return calculer(panier).then(function(r){ etat.remises = r; rafraichir(racine); });
      })
      .then(function(){ enCours = false; })
      .catch(function(){ enCours = false; });
  }

  /* Le tiroir se redessine a chaque ouverture et a chaque modification du panier :
     on garde un observateur actif, la pose etant idempotente. */
  function surveiller(racine){
    poser(racine);
    recalculer(racine);
    var minuteurRecalcul = null;
    var obs = new MutationObserver(function(){
      poser(racine);
      clearTimeout(minuteurRecalcul);
      minuteurRecalcul = setTimeout(function(){ recalculer(racine); }, 350);
    });
    obs.observe(racine, { childList: true, subtree: true });
  }

  var racineTrouvee = false;

  function chercher(){
    var hote = document.getElementById('opus-shadow-container');
    if (!hote) return false;
    var racine = hote.shadowRoot || hote;   /* si le shadow DOM est desactive dans Opus */
    racineTrouvee = true;
    /* Code club expose par snippets/dc-club-code.liquid, uniquement pour un client
       connecte dont le club est reconnu. Absent = message promo seul. */
    etat.codeClub = window.DC_CLUB_CODE || null;
    surveiller(racine);
    return true;
  }

  if (chercher()) return;

  /* L'app se charge apres la page : on attend son conteneur, sans s'eterniser. */
  var attente = new MutationObserver(function(){ if (!racineTrouvee && chercher()) stop(); });
  attente.observe(document.documentElement, { childList: true, subtree: true });
  var minuteur = setTimeout(stop, 20000);

  function stop(){
    clearTimeout(minuteur);
    try { attente.disconnect(); } catch(e){}
  }
})();
